import { IconProps } from "./icon.normal";

export interface ArrowIconProps extends IconProps {
  dir?: "up" | "down" | "left" | "right";
}
export const ArrowIcon: React.FC<ArrowIconProps> = ({
  size = "1em",
  color = "currentColor",
  dir = "left",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform:
          dir === "right"
            ? "rotate(180deg)"
            : dir === "up"
            ? "rotate(90deg)"
            : dir === "down"
            ? "rotate(-90deg)"
            : "rotate(0deg)",
      }}
    >
      <path
        d="M10.7071 11.2929C11.0976 11.6834 11.0976 12.3166 10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L10.7071 11.2929ZM6 8L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289L6 8ZM9.29289 3.29289C9.68342 2.90237 10.3166 2.90237 10.7071 3.29289C11.0976 3.68342 11.0976 4.31658 10.7071 4.70711L9.29289 3.29289ZM9.29289 12.7071L5.29289 8.70711L6.70711 7.29289L10.7071 11.2929L9.29289 12.7071ZM5.29289 7.29289L9.29289 3.29289L10.7071 4.70711L6.70711 8.70711L5.29289 7.29289Z"
        fill={color}
      />
    </svg>
  );
};
export const NarrowIcon: React.FC<ArrowIconProps> = ({
  size = "1em",
  color = "currentColor",
  dir = "down",
}) => {
  return (
    <svg
      width="1em"
      height="0.57em"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform:
          dir === "right"
            ? "rotate(-90deg)"
            : dir === "left"
            ? "rotate(90deg)"
            : dir === "up"
            ? "rotate(180deg)"
            : "rotate(0deg)",
      }}
    >
      <path
        d="M7 9L13.9282 -1.30507e-06L0.0717961 -9.36995e-08L7 9Z"
        fill={color}
      />
    </svg>
  );
};
